<template>
  <div class="table-responsive">
    <table class="table analytics-breakdown-table" style="width:100%;">
      <thead>
        <slot name="header" />
      </thead>
      <tbody>
        <slot name="body" />
      </tbody>
    </table>
  </div>
</template>

<style scoped>
table.analytics-breakdown-table > thead > tr > th,
table.analytics-breakdown-table > tbody > tr > th,
table.analytics-breakdown-table > tfoot > tr > th,
table.analytics-breakdown-table > thead > tr td,
table.analytics-breakdown-table > tbody > tr td,
table.analytics-breakdown-table > tfoot > tr td {
  border-top: 1px solid #f7f7f7;
  text-align: center;
  white-space: nowrap;
}
table.analytics-breakdown-table > thead > tr > th {
  border-bottom: 1px solid #efefef;
}
table.analytics-breakdown-table > tbody > tr td:not(:first-child) {
  padding-left: 3px;
  padding-right: 3px;
}

table.analytics-breakdown-table > tbody > tr.highlight td {
  background-color: #F9FAFD;
  border-top: 1px solid #efefef;
}

.analytics-breakdown-table > thead > tr > th:first-child {
  border-bottom: 0;
}
.analytics-breakdown-table > tbody > tr td:first-child {
  border-top: 0;
  font-weight: 600;
  text-align: left;
  font-size: 12px;
}
</style>

<script>
export default {
  name: 'AnalyticsBreakdownTable'
}
</script>